/**
 * Scope groups to organize permissions in the UI for admins.
 */
export var ScopeGroup;
(function (ScopeGroup) {
    ScopeGroup["CONTENT"] = "content";
    ScopeGroup["PROJECT_MANAGEMENT"] = "project_management";
    ScopeGroup["ORGANIZATION_MANAGEMENT"] = "organization_management";
    ScopeGroup["DATA"] = "data";
    ScopeGroup["SHARING"] = "sharing";
    ScopeGroup["AI"] = "ai";
    ScopeGroup["SPOTLIGHT"] = "spotlight";
})(ScopeGroup || (ScopeGroup = {}));
//# sourceMappingURL=scopes.js.map